import { ReactNode } from "react";

export const IconeRnge: React.FC<{ size?: number; color?: string }> = ({
    size = 24,
    color = "black",
}) => (

    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="250.000000pt" height="250.000000pt" viewBox="0 0 250.000000 250.000000"
        preserveAspectRatio="xMidYMid meet">
        <metadata>
            Created by potrace 1.10, written by Peter Selinger 2001-2011
        </metadata>
        <g transform="translate(0.000000,250.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path d="M10 1245 l0 -1245 1245 0 1245 0 0 1245 0 1245 -1245 0 -1245 0 0
-1245z m1240 610 l0 -605 -605 0 -605 0 0 605 0 605 605 0 605 0 0 -605z
m1160 5 l0 -530 -135 0 -135 0 0 395 0 395 -260 0 -260 0 0 -395 0 -395 -135
0 -135 0 0 530 0 530 530 0 530 0 0 -530z m78 -1243 l2 -607 -607 2 -608 3 -3
595 c-1 327 0 601 3 608 3 10 130 12 607 10 l603 -3 3 -608z m-1318 398 l0
-135 -395 0 -395 0 0 -260 0 -260 265 0 265 0 0 60 0 60 -212 2 -213 3 -3 131
-3 132 248 4 c136 2 292 2 345 0 l97 -4 3 -202 c2 -110 2 -258 0 -328 l-3
-128 -530 0 -529 0 0 530 0 530 530 0 530 0 0 -135z"/>
            <path d="M110 1860 l0 -530 135 0 135 0 0 395 0 395 395 0 395 0 0 135 0 135
-530 0 -530 0 0 -530z"/>
            <path d="M1350 620 l0 -530 530 0 530 0 0 135 0 135 -395 0 -396 0 3 62 3 63
268 3 267 2 0 130 0 130 -270 0 -270 0 0 65 0 65 395 0 395 0 0 135 0 135
-530 0 -530 0 0 -530z"/>
        </g>
    </svg>
);


export const logoRednaxel: ReactNode = <IconeRnge />;